import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=41082a4c&scoped=true"
import script from "./NoResult.vue?vue&type=script&lang=js"
export * from "./NoResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41082a4c",
  null
  
)

export default component.exports